import { useEffect, useState } from 'react';

export function useReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);
    
    const handler = (event) => setPrefersReducedMotion(event.matches);
    mediaQuery.addEventListener('change', handler);
    
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);
  
  return prefersReducedMotion;
}

// Animation variants that respect prefers-reduced-motion
export function useAnimationVariants() {
  const prefersReducedMotion = useReducedMotion();
  
  const fadeIn = prefersReducedMotion
    ? { initial: {}, animate: {}, exit: {} }
    : {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      };
  
  const fadeInUp = prefersReducedMotion
    ? { initial: {}, animate: {}, exit: {} }
    : {
        initial: { opacity: 0, y: 30 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -30 }
      };
  
  const fadeInScale = prefersReducedMotion
    ? { initial: {}, animate: {}, exit: {} }
    : {
        initial: { opacity: 0, scale: 0.95 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.95 }
      };
  
  const slideInLeft = prefersReducedMotion
    ? { initial: {}, animate: {}, exit: {} }
    : {
        initial: { opacity: 0, x: -50 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: 50 }
      };
  
  const slideInRight = prefersReducedMotion
    ? { initial: {}, animate: {}, exit: {} }
    : {
        initial: { opacity: 0, x: 50 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -50 }
      };
  
  const staggerContainer = prefersReducedMotion
    ? { initial: {}, animate: {} }
    : {
        initial: {},
        animate: { transition: { staggerChildren: 0.1 } }
      };
  
  const hoverScale = prefersReducedMotion
    ? {}
    : { scale: 1.02 };
  
  const tapScale = prefersReducedMotion
    ? {}
    : { scale: 0.98 };
  
  const buttonHover = prefersReducedMotion
    ? {}
    : { scale: 1.05, transition: { duration: 0.2 } };
  
  const buttonTap = prefersReducedMotion
    ? {}
    : { scale: 0.95 };
  
  return {
    prefersReducedMotion,
    fadeIn,
    fadeInUp,
    fadeInScale,
    slideInLeft,
    slideInRight,
    staggerContainer,
    hoverScale,
    tapScale,
    buttonHover,
    buttonTap
  };
}

// Page transition variants
export const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }
  },
  exit: { 
    opacity: 0, 
    y: -20,
    transition: { duration: 0.3 }
  }
};
